import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../service/common.service';
import { Ruolo } from '../../models/ruolo';
import { Articolo } from '../../models/articolo';
import { Lavorazione } from '../../models/lavorazione';
import { Lavorazionearticolo } from '../../models/lavorazionearticolo';
import { Catalogo } from '../../models/catalogo';
import { MatSelectionList } from '@angular/material/list';
import { MatSelectionListChange } from '@angular/material/list';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';

@Component({
  selector: 'app-lavorazionearticoli',
  templateUrl: './lavorazionearticoli.component.html',
  styleUrls: ['./lavorazionearticoli.component.css']
})
export class LavorazionearticoliComponent implements OnInit {
  IPAddress:string;
  Port:string;
  Protocol:string;
  selectedValueCatalogo:string;
  cataloghi: Catalogo[];
  currentCatalogo:Catalogo;
  currentArticolo:Articolo;
  lavorazionearticoli:Lavorazionearticolo[]=[];
  lavorazionearticoliselezionati:Lavorazionearticolo[]=[];
  selectedArticoli:Array<Articolo>=[];
  articoli: Articolo[]=[];
  articoliincache: Articolo[]=[];
  articoliselezionati: Articolo[]=[];
//  @ViewChild(MatSelectionList, {static: true})
  private selectionList:  MatSelectionList;
  private associatedSelectionList:  MatSelectionList;
  associatedarticoli:Array<Lavorazionearticolo>=[];
  nomelavorazione:string;
  nomestatolavorazione:string;
  filtroCodicearticolo:string;
  filtroDescrizione:string;

  articolimodificati:Array<{Id: number, Modificato: string}>=[];

  displayedColumns: string[] = [
  //  "sel",
    "Id",
    "Codicearticolo",
    "Descrizione",
    "Categoria",
    "Costo",
    "Iva",
    "Prezzo",
    "Giacenza",
    "Unitamisura",
    "add"];

    displayedColumns2: string[] = [
  //    "sel2",
    "Id",
    "Codicearticolo",
    "Descrizione",
    "Costo",
    "Iva",
    "Prezzo",
    "Quantita",
    "Unitamisura",
    "Prezzototale",
    "remove",
    "save",
    "detail"];

    sortedDirection:Map<string, boolean>=new Map<string, boolean>();
    dataSource = new MatTableDataSource<Articolo>(this.articoli);
    dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);

    @ViewChild('paginator') paginator: MatPaginator;
    @ViewChildren(MatSelectionList) selections: QueryList<MatSelectionList>;


  constructor(private router: Router, private commonService: CommonService, private httpClient: HttpClient) {
    this.filtroCodicearticolo="";
    this.filtroDescrizione="";
  }

  ngOnInit(): void {
    if (environment.address.isLocal){
      this.IPAddress=environment.address.localIP;
      this.Port=environment.address.localPort;
      this.Protocol=environment.address.localProtocol;
    }else{
      this.IPAddress=environment.address.remoteIP;
      this.Port=environment.address.remotePort;
      this.Protocol=environment.address.remoteProtocol;
    }

    this.commonService.getAllCataloghi().subscribe((res) => {
        this.cataloghi = res;
        this.manageChangeCatalogo();
        this.lavorazionearticoli=[];
        this.lavorazionearticoliselezionati=[];
        if (this.commonService.selectedLavorazione!=undefined) {
          this.nomelavorazione=this.commonService.selectedLavorazione.Nome;
          this.nomestatolavorazione=this.commonService.selectedLavorazione.Statolavorazione.Nome;
          this.commonService.getAllLavorazionearticoli(this.commonService.selectedLavorazione.Codice).subscribe((res1) => {
          this.lavorazionearticoli=res1;
          this.articolimodificati=[];
          this.lavorazionearticoli.forEach(la => {
            this.articolimodificati.push({Id:la.Id, Modificato:'NO'});
          });


          this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
  //        this.lavorazionearticoli.forEach(element => {
  //            this.associatedarticoli.push(element);
  //          });

          });
        }else{
          this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
        }
    });

    this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Id",true);
    this.sortedDirection.set("Catalogo",true);
    this.sortedDirection.set("Codicecatalogo",true);
    this.sortedDirection.set("Codicearticolo",true);
    this.sortedDirection.set("Descrizione",true);
    this.sortedDirection.set("Categoria",true);
    this.sortedDirection.set("Costo",true);
    this.sortedDirection.set("Iva",true);
    this.sortedDirection.set("Prezzo",true);
    this.sortedDirection.set("Note",true);
    this.sortedDirection.set("Giacenza",true);
    this.sortedDirection.set("Unitamisura",true);
  }
  ngAfterViewChecked() {
      if (this.selections.length===2){
        this.selectionList=this.selections.toArray()[0] as MatSelectionList;
        this.associatedSelectionList=this.selections.toArray()[1] as MatSelectionList;
      }
  }


  manageChangeCatalogo(){
    if (this.selectedValueCatalogo===undefined || this.selectedValueCatalogo===""){
     return;
    }
//    this.lavorazionearticoli=[];
    this.lavorazionearticoliselezionati=[];
    this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
    this.cataloghi.forEach(element => {
      if (this.selectedValueCatalogo === element.Nome){
        this.currentCatalogo=element;
        this.commonService.getAllArticoliByCatalogo(this.currentCatalogo.Codice).subscribe((res) => {
          this.articoli=res;
          this.articoliincache=res;
          this.refreshLista(this.articoli);
    //      this.commonService.getAllLavorazionearticoli(this.commonService.selectedLavorazione.Codice).subscribe((res1) => {
    //        this.lavorazionearticoli=res1;
    //        this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
    //      });
        });
      }
    });
  }

  refreshLista(listaarticoli:Articolo[]){
    this.articoli=listaarticoli;
    this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
    this.dataSource.paginator = this.paginator;
  }

  onQuantitaKeyup(la:Lavorazionearticolo, event:any){
    if (isNaN(event.target.value)){
      event.target.value=la.Quantita;
    }else{
      la.Quantita=Number(event.target.value);
    }
    la.Prezzototale=Number((la.Prezzo*la.Quantita).toFixed(2));
    let index=this.articolimodificati.findIndex(a => a.Id=la.Id);
    if (index>-1){
      this.articolimodificati[index].Modificato='SI';
    }
  }

  onPrezzoKeyup(la:Lavorazionearticolo, event:any){
    if (isNaN(event.target.value)){
      event.target.value=la.Prezzo;
    }else{
      la.Prezzo=Number(event.target.value);
    }
    la.Prezzototale=Number((la.Prezzo*la.Quantita).toFixed(2));
    let index=this.articolimodificati.findIndex(a => a.Id=la.Id);
    if (index>-1){
      this.articolimodificati[index].Modificato='SI';
    }
  }

  save() {

      this.lavorazionearticoli.forEach(la => {
            this.commonService.saveLavorazionearticolo(la).subscribe(data => {
              let rc=JSON.stringify(data)
              if (rc==="0"){
                console.log("Salvataggio effettuato con successo:"+rc);
              }else{
                console.log("Errore salvataggio");
              }
            });

      });
  }
/*
  selezionato(articolo:Articolo){
    const indexOfObject = this.articoliselezionati.findIndex((element) => {
      return element.Codicearticolo === articolo.Codicearticolo;
    });
    if (indexOfObject !== -1) {
      this.articoliselezionati.splice(indexOfObject, 1);
    }else{
      this.articoliselezionati.push(articolo);
    }
  }
  addarticoliselezionati(){
    this.articoliselezionati.forEach(element => {
      const indexOfObject = this.lavorazionearticoli.findIndex((la) => {
        return la.Articolo.Id === element.Id;
      });
      if (indexOfObject!==-1) { // Se si vuole aggiungere un articolo gia' aggiunto si esce
        return;
      }else { // Si constrolla se precedentemente si era aggiunto e poi tolto: in questo caso rimarrebbe traccia in lavorazionearticoliselezionati
        const indexOfObject2 =this.lavorazionearticoliselezionati.findIndex((la2) => {
          return la2.Articolo.Id === element.Id;
        });
        if (indexOfObject2!==-1) {
          this.lavorazionearticoliselezionati.splice(indexOfObject2, 1);
        }
      }
      let la:Lavorazionearticolo=new Lavorazionearticolo();
      la.Lavorazioneid=this.commonService.selectedLavorazione.Codice;
      la.Articolo=element;
      la.Costo=element.Costo;
      this.commonService.saveLavorazionearticolo(la).subscribe((data) => {
        let rc: number;
        rc=Number(JSON.stringify(data));
        if (rc>0){
          la.Id=rc;
          this.lavorazionearticoli.push(la);
          this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
        }else{
          alert("Errore nella aggiunta dell'elemento selezionato");
        }
      });
    });
  }
*/
  addArticolo(articolo:Articolo){
    const indexOfObject = this.lavorazionearticoli.findIndex((element) => {
      return element.Articolo.Codicearticolo === articolo.Codicearticolo;
    });
    if (indexOfObject !== -1) {
      return;
    }
    let la:Lavorazionearticolo=new Lavorazionearticolo();
    la.Lavorazioneid=this.commonService.selectedLavorazione.Codice;
    la.Articolo=articolo;
    la.Costo=articolo.Costo;
    la.Unitamisura=articolo.Unitamisura;
    let iva=articolo.Costo*articolo.Iva/100;
    la.Iva=Number(iva.toFixed(2));
    let prezzo=la.Costo+la.Iva;
    la.Prezzo=Number(prezzo.toFixed(2));
    this.commonService.saveLavorazionearticolo(la).subscribe((data) => {
      let rc: number;
      rc=Number(JSON.stringify(data));
      if (rc>0){
        la.Id=rc;
        this.lavorazionearticoli.push(la);
        this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
      }else{
        alert("Errore nella aggiunta dell'elemento selezionato");
      }
    });
  }
/*
  selezionatolavorazionearticolo(lavorazionearticolo:Lavorazionearticolo){
    const indexOfObject = this.lavorazionearticoliselezionati.findIndex((element) => {
      return element.Id === lavorazionearticolo.Id;
    });
    if (indexOfObject !== -1) {
      this.lavorazionearticoliselezionati.splice(indexOfObject, 1);
    }else{
      this.lavorazionearticoliselezionati.push(lavorazionearticolo);
    }
  }

  removelavorazioniarticoliselezionati(){
    console.log("Lavorazionearticoliselezionati:"+this.lavorazionearticoliselezionati.length);
    this.lavorazionearticoliselezionati.forEach(element => {
      const index = this.lavorazionearticoli.findIndex(la => la.Articolo.Id === element.Articolo.Id);
      if (index !== -1) {
        this.commonService.deleteLavorazionearticolo(element).subscribe((data) => {
          console.log("Togli:"+element.Articolo.Id);
          let rc: number;
          rc=Number(JSON.stringify(data));
          if (rc===element.Id){

            this.lavorazionearticoli.splice(index, 1);
            this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
          }else{
            alert("Errore nella rimozione dell'elemento selezionato");
          }
        });
      }
    });
  }
*/
  removeArticolo(lavorazionearticolo:Lavorazionearticolo){
    this.commonService.deleteLavorazionearticolo(lavorazionearticolo).subscribe((data) => {
      console.log("Togli:"+lavorazionearticolo.Articolo.Id);
      let rc: number;
      rc=Number(JSON.stringify(data));
      if (rc===lavorazionearticolo.Id){
        const index = this.lavorazionearticoli.findIndex(la => la.Articolo.Id === lavorazionearticolo.Articolo.Id);
        this.lavorazionearticoli.splice(index, 1);
        this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
        this.manageChangeCatalogo();
      }else{
        alert("Errore nella rimozione dell'elemento selezionato");
      }
    });
  }

  saveArticolo(lavorazionearticolo:Lavorazionearticolo){
    this.commonService.saveLavorazionearticolo(lavorazionearticolo).subscribe((data) => {
      console.log("Salva:"+lavorazionearticolo.Articolo.Id);
      let rc: number;
      rc=Number(JSON.stringify(data));
      if (rc===lavorazionearticolo.Id){
        alert("Articolo salvato con successo");
        this.articolimodificati.push({Id:lavorazionearticolo.Id, Modificato:'NO'});
        this.manageChangeCatalogo();
      }else if (rc===-2){
        alert("Quantità richiesta non sufficiente");
      }else if (rc===-1){
        alert("Errore salvataggio articolo selezionato");
      }
    });
  }

  detailArticolo(lavorazionearticolo:Lavorazionearticolo){
    this.commonService.selectedLavorazione=undefined;
    this.commonService.selectedArticolo=lavorazionearticolo.Articolo;
    this.router.navigate(['addarticolo']);
  }

  isModificato(la:Lavorazionearticolo):string{
    let temp=this.articolimodificati.filter(a => a.Id=la.Id);
    if (temp.length>0){
      return(temp[0].Modificato);
    }else{
      return '';
    }
  }
  cancel(){
    //this.selectedValueRuolo="";
    this.selectedValueCatalogo="";
    //this.users=[];
    //this.associatedarticoli=[];
    this.articoli=[];
    this.articoliincache=[];
    this.refreshLista(this.articoli);
  }
  back(){
    this.commonService.selectedLavorazione=undefined;
    this.router.navigate(['lavorazioni']);
  }

  add(){
    const checkedItems = this.selectionList.selectedOptions.selected;
    this.selectedArticoli=checkedItems.map(i => {
      i.selected=false;
      return i.value});
    this.selectedArticoli.forEach(element => {
        const index = this.associatedarticoli.findIndex(lavorazionearticolo => (lavorazionearticolo.Articolo.Codicearticolo === element.Codicearticolo));
      if (index != undefined && index<0){
        let la:Lavorazionearticolo=new Lavorazionearticolo();
        la.Lavorazioneid=this.commonService.selectedLavorazione.Codice;
        la.Articolo=element;

        this.commonService.saveLavorazionearticolo(la).subscribe((data) => {
          let rc: any;
          rc=JSON.stringify(data);
          if (rc==0){
            this.associatedarticoli.push(la);
            this.lavorazionearticoli.push(la);
            this.dataSource2 = new MatTableDataSource<Lavorazionearticolo>(this.lavorazionearticoli);
          }else{
            alert("Errore nella aggiunta dell'elemento selezionato");
          }
        });
      }

    });

  }
  remove(){
    const checkedItems = this.associatedSelectionList.selectedOptions.selected;
    const tempArticoli:Lavorazionearticolo[]=checkedItems.map(i => i.value);
    tempArticoli.forEach(element1 => {
      const index = this.associatedarticoli.findIndex(lavorazionearticolo => lavorazionearticolo.Articolo.Codicearticolo === element1.Articolo.Codicearticolo);
      this.commonService.deleteLavorazionearticolo(this.associatedarticoli[index]).subscribe((data) => {
        let rc: any;
        rc=JSON.stringify(data);
        if (rc==this.associatedarticoli[index].Id){
          this.associatedarticoli.splice(index, 1);
        }else{
          alert("Errore nella rimozione dell'elemento selezionato");
        }
      });
    });
  }

  getConfigurazione(){
    return configurazione.articolo;
  }

  manageClick(attributo: string){
    let tempList:Articolo[];
    tempList=this.articoli;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);
     this.dataSource = new MatTableDataSource<Articolo>(this.articoli);

   }

  onFiltroCodicearticoloKeyup(event:any){
    this.articoli=this.articoliincache;
    if (event.target.value!=undefined){
      this.articoli = this.articoli.filter(a=> a.Codicearticolo.indexOf(event.target.value)>-1 && (this.filtroDescrizione==="" || this.filtroDescrizione===undefined || a.Descrizione.indexOf(this.filtroDescrizione)>-1));
      this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
    }
  }

  onFiltroDescrizioneKeyup(event:any){
    this.articoli=this.articoliincache;
    if (event.target.value!=undefined){
      this.articoli = this.articoli.filter(a=> a.Descrizione.indexOf(event.target.value)>-1 && (this.filtroCodicearticolo==="" || this.filtroCodicearticolo===undefined || a.Codicearticolo.indexOf(this.filtroCodicearticolo)>-1));
      this.dataSource = new MatTableDataSource<Articolo>(this.articoli);
    }
  }

  isReadonly(){
    return this.nomestatolavorazione==='Conclusa';
  }


}
